<ng-container *ngIf="isEmployeeBenefit">
  <app-company-identifier *ngIf="this.router.url.startsWith('/employee-benefit/access')"></app-company-identifier>
  <app-product-selection *ngIf="this.router.url.startsWith('/employee-benefit/products')"></app-product-selection>
</ng-container>

<app-product-brand-selection fxFlex fxLayoutAlign="center start"
                             *ngIf="this.router.url.startsWith('/product')"></app-product-brand-selection>
<ng-container
  *ngIf="
    !this.router.url.startsWith('/product')
    && !this.router.url.startsWith('/alloy-sdk')
    && !this.router.url.startsWith('/maintenance')
    && !this.router.url.startsWith('/get-started')
    && !this.router.url.startsWith('/account-holder/get-started')
    && !isBankingCenter
    && !isEmployeeBenefit
    && (coreService.isDataLoaded | async)"
>
  <header>
    <app-header id="header" fxLayout="row" class="header-container" style="margin-bottom: 8px;"></app-header>
  </header>
  <div>
    <app-maintenance-banner></app-maintenance-banner>
    <app-fdic-img></app-fdic-img>
  </div>
  <main id="main-area"  [ngClass]="{'main-area':!isVerify}" fxFlex fxLayout="column" fxLayoutAlign="start center">
    <div *ngIf="!applicationIdleService.isApplicationAbandoned" fxFlex fxLayout="column" [ngClass]="[isVerify ? 'code-verification-container' : isNarrowComponent ? 'narrow-content-container' : isNarrowJointComponent? 'narrow-joint-content-container': 'content-container', isCardComponent? 'card' : '']">
      <mat-sidenav-container #sidenav id="sidenav" [hasBackdrop]="false"
                             [ngClass.xs]="{'main-sidenav-container': !isVerify, 'main-sidenav-mobile': !isVerify}"
                             [ngClass.gt-xs]="{'main-sidenav-container': !isVerify}">
        <mat-sidenav-content [ngClass]="{'main-content': !isVerify}">
          <div fxLayout="column">
            <app-status-tracker fxFlexOrder="1" fxFlexOrder.gt-xs="2" *ngIf="showStatusTracker$ | async"></app-status-tracker>
          </div>
          <div class="content">
            <router-outlet></router-outlet>
          </div>
          <ng-container *ngIf="canAccess && !alwaysHideNavForRoutes">
            <app-actions [isInJointMaintenanceFlow]="(isInJointMaintenanceFlow$ | async)!"></app-actions>
          </ng-container>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
    <div *ngIf="applicationIdleService.isApplicationAbandoned" id="application-abandoned-area" class="content-container">
      <app-abandoned-card></app-abandoned-card>
    </div>
  </main>
  <app-app-store-banner *ngIf="mainLayout.isAppStoreBannerVisible$ | async"></app-app-store-banner>
  <footer id="sticky-footer" *ngIf="!isVerify">
    <div [ngClass]="'container-mobile'">
    </div>
    <app-footer></app-footer>
  </footer>
</ng-container>

<ng-container *ngIf="this.router.url.startsWith('/banking-center')">
  <header>
    <app-header fxLayout="row" class="header-container" style="margin-bottom: 8px;"></app-header>
    <app-fdic-img></app-fdic-img>
  </header>
  <app-banking-center></app-banking-center>
</ng-container>

<ng-container *ngIf="this.router.url.startsWith('/get-started') || this.router.url.startsWith('/account-holder/get-started')">
  <header>
    <app-header fxLayout="row" class="header-container" style="margin-bottom: 8px;"></app-header>
    <app-fdic-img></app-fdic-img>
  </header>
  <main class="page-break-container">
    <page-break></page-break>
  </main>
  <footer id="sticky-footer">
    <app-footer></app-footer>
  </footer>
</ng-container>

<ng-container *ngIf="this.router.url.startsWith('/branch')" style="overflow: hidden;">
  <header>
    <app-header fxLayout="row" class="header-container" style="margin-bottom: 8px;"></app-header>
    <app-fdic-img></app-fdic-img>
  </header>
  <app-branch></app-branch>
</ng-container>

<ng-container *ngIf="this.router.url.startsWith('/maintenance')" style="overflow: hidden;">
  <app-maintenance></app-maintenance>
</ng-container>

<ng-container *ngIf="!(coreService.isDataLoaded | async) && !isBankingCenter && !isEmployeeBenefit && !this.router.url.startsWith('/alloy-sdk')">
  <div class="logo">
  </div>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-container>

<div *ngIf="this.router.url.startsWith('/alloy-sdk') && canAccess" style="background-color: white !important; height: 100% !important;">
  <app-alloy-sdk-frame></app-alloy-sdk-frame>
</div>

<ng-container *ngIf="showSuccessTracker$ | async">
  <img width="1px" height="1px" [src]="trackingUrl$ | async" />
</ng-container>
